import React, {useEffect, useState} from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Fade,
} from "@mui/material"
import { Close as CloseIcon, InfoOutlined as InfoIcon, CheckCircleOutline as CheckIcon } from "@mui/icons-material"
import { getData } from "../../../services/library";

function ModalAyuda({ 
  open, 
  setOpen, 
  modulo,
  titulo,
  subtitulo,
  tip
}) {
  const [helpItems, setHelpItems]=useState();

  useEffect(()=>{
    getData(`/ayudas/modulo/${modulo}`, setHelpItems)
  },[])

 
  /* ---------------------------- HANDLERS -------------------------------  */
  const handleClose = () => setOpen(false)
  /* ---------------------------- RENDER -------------------------------  */
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 400 }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 24px 48px rgba(0, 0, 0, 0.15)",
          background: "linear-gradient(to bottom, #ffffff, #f8f9fa)",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 2,
          pt: 3,
          px: 3,
          background:"#164e63",
          color: "white",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <InfoIcon sx={{ fontSize: 28 }} />
          <Typography variant="h5" component="div" sx={{ fontWeight: 600 }}>
            {titulo || "Centro de ayuda"}
          </Typography>
        </Box>
        <IconButton
          onClick={handleClose}
          sx={{
            color: "white",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          }}
          aria-label="cerrar"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ px: 3, py: 3 }}>
        <Typography
          variant="body1"
          sx={{
            mb: 3,
            color: "#64748b",
            fontSize: "0.95rem",
            lineHeight: 1.6,
          }}
        >
         {subtitulo || ""}
        </Typography>

        <List sx={{ p: 0 }}>
          {helpItems?.map((item, index) => (
            <React.Fragment key={index}>
              <ListItem
                sx={{
                  px: 0,
                  py: 2,
                  alignItems: "flex-start",
                  "&:hover": {
                    backgroundColor: "rgba(102, 126, 234, 0.04)",
                    borderRadius: 2,
                    px: 2,
                  },
                  transition: "all 0.2s ease",
                }}
              >
                <ListItemIcon sx={{ minWidth: 40, mt: 0.5 }}>
                  <CheckIcon
                    sx={{
                      color: "#667eea",
                      fontSize: 24,
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={item.ayuda}
                  primaryTypographyProps={{
                    sx: {
                      fontSize: "0.95rem",
                      lineHeight: 1.7,
                      color: "#334155",
                    },
                  }}
                />
              </ListItem>
              {index < helpItems.length - 1 && <Divider sx={{ my: 0.5, opacity: 0.6 }} />}
            </React.Fragment>
          ))}
        </List>
        {/* {tip && ( */}
          <Box
            sx={{
              mt: 4,
              p: 2.5,
              borderRadius: 2,
              background: "linear-gradient(135deg, #667eea15 0%, #764ba215 100%)",
              border: "1px solid #667eea30",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "#475569",
                fontSize: "0.9rem",
                lineHeight: 1.6,
                textAlign: "center",
              }}
            >
              💡 <strong>Tip:</strong> {tip || `Si no encontraste la solución a tu problema en esta ayuda, comunicate con soporte.`} 
            </Typography>
          </Box>

        {/* )} */}
      </DialogContent>
    </Dialog>
  )
}

export default ModalAyuda
